import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 80 80"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "80",
      height: "80",
      fill: "#101828",
      rx: "40"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M28.7 66a1 1 0 0 1-.993-.873l-5.562-43.27a1 1 0 0 1 .992-1.127h6.795c.272 0 .502.2.54.47l.628 4.512c.024.171.276.159.282-.014a.14.14 0 0 1 .023-.072q1.735-2.653 4.696-4.105Q39.081 20 42.991 20q4.78 0 8.629 2.312a17 17 0 0 1 6.083 6.206Q60 32.414 60 37.28q0 4.808-2.235 8.762t-6.083 6.267q-3.849 2.252-8.753 2.252-3.661 0-6.766-1.4-2.79-1.34-4.535-3.703a.686.686 0 0 1 .031-.844.713.713 0 0 1 1.25.32l3.028 15.879A1 1 0 0 1 34.955 66zm13.298-18.74q2.794 0 4.966-1.279a8.7 8.7 0 0 0 3.352-3.529q1.242-2.25 1.242-5.172 0-2.92-1.242-5.11a8.7 8.7 0 0 0-3.352-3.53q-2.172-1.338-4.966-1.338-2.67 0-4.841 1.277-2.111 1.278-3.352 3.59-1.18 2.252-1.18 5.111 0 2.921 1.18 5.172 1.24 2.252 3.352 3.53 2.172 1.277 4.841 1.277"
    }, null, -1)
  ])))
}
export default { render: render }